import muster from '@dbk-legacy/muster';
import { variable, redirectOn, constant } from '@dbk-legacy/muster/helpers';
import { getValues, ref, watchValues } from '@dbk-legacy/muster/utils';
import { Platform, AsyncStorage, Alert } from 'react-native';
import WSO2Connect from '../../../utils/wso2-connect';
import format from 'date-fns/format';
import Guid from '../../../utils/guid';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { encode } from 'base-64';

export default () => muster()
  .path('search.getRecentSearchData', {
    call: async ({ req, res }, { get, set }) => {
      const noOfRows = req.args[0];
      const [portfolioData] = await getValues(get('app.user.selectedPortfolioData'));
      const numberOfRows = `pos-${noOfRows}`;
      const [oReturn] = await getValues(get(`roster.data.positionsearch.getRecentSearch["${numberOfRows}"]`));
      isValidJsonString(oReturn).then(async (data) => {
        data.forEach(function (value) {
          if (value.psDesc === undefined) {
            value.psDesc = null;
          }
        });
        await set('search.searchData', data);
      }).catch(async (error) => {
        let searchData = [];
        let json_obj = {};
        json_obj['statusCode'] = '401';
        searchData.push(json_obj);
        await set('search.searchData', searchData);
      });
    }
  })
  .path('search.getPortfolioOrPositionData', {
    call: async ({ req, res }, { get, set }) => {
      let searchText = req.args[0];
      var positionData = [], json_obj = {};
      try {
        await set('search.searchData', positionData);
        if (searchText.length >= 3) {
          searchText = searchText.toUpperCase();
          const text = `pos-${searchText}`;
          const [oReturn] = await getValues(get(`roster.data.positionsearch.getPortfolioOrPositionData["${text}"]`));
          isValidJsonString(oReturn).then(async (positionData) => {
            if (positionData == '' || positionData === undefined || positionData.length == 0)
              positionData = [];
            positionData.forEach(function (value) {
              if (value.psDesc === undefined) {
                value.psDesc = null;
              }
            });
            const portfolios = await getValues(get(['search.portfolioIds']));
            if (portfolios.length > 0) {
              for (let value of portfolios[0]) {
                let pfId = value.title;
                if (!value.relId && pfId.startsWith(searchText)) {
                  json_obj = {};
                  json_obj['pfId'] = pfId;
                  json_obj['psPosId'] = null;
                  json_obj['psDesc'] = '';
                  positionData.push(json_obj);
                }
              }
            }
            await set('search.searchData', positionData);
          }).catch(async (error) => {
            // let searchData = [];
            // let json_obj = {};
            // json_obj['statusCode'] = '401';
            // searchData.push(json_obj);
            const portfolios = await getValues(get(['search.portfolioIds']));
            if (portfolios.length > 0) {
              for (let value of portfolios[0]) {
                let pfId = value.title;
                if (!value.relId && pfId.startsWith(searchText)) {
                  json_obj = {};
                  json_obj['pfId'] = pfId;
                  json_obj['psPosId'] = null;
                  json_obj['psDesc'] = '';
                  positionData.push(json_obj);
                }
              }
            }
            await set('search.searchData', positionData);
          });
        }
      } catch (ex) {
        console.log('error at muster in search and error is  ', ex);
      }
    },
  })
  .path('search.getCioSearchDataSecond', {
    call: async ({ req }, { get, set, call }) => {
      console.log("Second call to CIO");
      let searchKeyword = req.args[0];
      let offSet = req.args[1];
      let pageLimit = req.args[2];
      let oResult = [];
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      const hasSpecialChar = format.test(searchKeyword);
      if (searchKeyword.length >= 3 && !hasSpecialChar) {

        let [cioSearchData1,
          roleid,
          lazyLoadingCount,
          endOfRecords] = await getValues(get(['search.cioSearchData1',
            'cioinsights.roles',
            'search.lazyLoadingCount',
            'search.endOfRecordsMore'
          ]));
        const guidStr = Guid();
        let oReturn = await getValues(get(`roster.data.cioinsights.getSearchData["${roleid}"]["!${searchKeyword}"]["i${offSet}"]["i${pageLimit}"]["${guidStr}"]`));

        if (oReturn[0].$type == "error") {
          await set('search.cioSearchData1', []);
        }
        else {

          oResult = JSON.parse(oReturn);
          await set('search.lazyLoadingCount', oResult.offSet);
          await set('search.endOfRecordsMore', oResult.endOfRecords);
          await set('search.cioSearchData1', oResult.cio);
          //await set('search.cioSearchData1', oResult.cio);
          console.log("cioinsights.getData: first set");
        }


      }
      else {
        await set('search.cioSearchData1', []);
      }
    }
  })
  .path('search.getInvestmentIdeas', {
    call: async ({ req, res }, { get, set }) => {
      let searchText = req.args[0];
      try {
        if (searchText.length >= 3) {
          searchText = searchText.toUpperCase();
          const text = `invest-${searchText}`;
          const [oReturn] = await getValues(get(`roster.data.investmentIdeas.searchInvestmentIdeas["${text}"]`));
          isValidJsonString(oReturn).then(async (investmentData) => {
            if (investmentData.errorMsg) {
              await set('search.investmentIdeaSearchData', []);
            } else {
              await set('search.investmentIdeaSearchData', investmentData.data.records);
            };
          }).catch(async (error) => {
            await set('search.investmentIdeaSearchData', []);
          });
        }
      } catch (ex) {
        await set('search.investmentIdeaSearchData', []);
      }
    },
  })
  .path('search.clearFilters', {
    call: async ({ req }, { set }) => {
      await set([
        { path: `search.filter.positionId`, value: null },
        { path: `search.filter.portfolioId`, value: null },
        { path: `search.cioSearchData1`, value: [] },
        { path: `search.investmentIdeaSearchData`, value: []},
      ]);
    },
  })
  .path('search.searchData', variable())
  .path('search.filter.positionId', variable())
  .path('search.filter.portfolioId', variable())
  .path('search.searchBarVisible', ({ res }, { get }) =>
    watchValues(get(['ui.history.currentLocation.pathname']))
      .map(([pathname]) => {

        const params = pathname.split('/');
        const isVisible = params.length > 1 && params[1] == 'search' ? true : false;

        return {
          path: 'search.searchBarVisible',
          value: isVisible,
        };

      })
  )
  .path('search.onSaveOrUpdateSearchText', {
    call: async ({ req, res }, { get, set }) => {
      const obj = req.args[0];
      const guidStr = Guid();
      const base64 = encode(JSON.stringify(obj));
      const [oReturn] = await getValues(get(`roster.data.positionsearch.onSaveOrUpdateSearchText["${base64}"]["${guidStr}"]`));
    },
  })
  .path('search.portfolioIds', variable())
  .path('search.selectedAssetClass', variable())
  .path('search.cioSearchData1', variable([]))
  .path('search.investmentIdeaSearchData', variable([]))
  // .path('search.cioSearchData1', variable([]))
  .path('search.endOfRecords', variable())
  .path('search.endOfRecordsMore', variable())
  .path('search.lazyLoadingCount', variable(0))
  .path('search.hideCIOList', variable(true))
  .path('search.hidePositionList', variable(true))
  .path('search.busy', variable())
  .path('search.fromFirstEndpoint', variable())
  .path('search.clearSearchSelectedAssetClass', {
    call: async ({ req }, { set }) => {
      await set([
        { path: `search.selectedAssetClass`, value: undefined },
      ]);
    },
  })
  .path('search.clearSearchData', {
    call: async ({ req }, { set }) => {
      await set([
        { path: `search.searchData`, value: [] },
        { path: `search.cioSearchData1`, value: [] },
        { path: `search.investmentIdeaSearchData`, value: []},
      ]);
    },
  });